<div class="tile-type-mat-icon-wrapper">
   <mat-icon>grid_3x3</mat-icon>
</div>
